import { METHOD_PUT } from '../constants/apis';
import { STRAPI_URL } from '../constants/url';
import { getQueryString } from './Population';

export default async function PutRecord(
	api: string,
	id: number,
	body: any,
	poplevel: any = [],
	filter: any[] = [],
	sort: any[] = [],
	pagination: object = {},
	fields: any = []
) {
	let response = await fetch(`${STRAPI_URL}/api/${api}/${id}${getQueryString(poplevel, filter, sort, pagination, fields)}`, {
		method: METHOD_PUT,
		credentials: 'include',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(body),
	});
	if (!response.ok) {
		throw new Error(await response.text());
	}
	const responseData = await response.json();
	return responseData;
}
